import React, { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { NoContextTabView } from '@/components/layouts/TabView';
import { getUnlayerEmailTabs } from '@/app/tabs';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { TemplatesIcon } from '@/components/icons/TemplatesIcon';

/**
 * Top-level tab shell for the Unlayer emails page. Renders the Emails and AI templates
 * tabs, hiding the AI tab when the unlayerAiEmailTemplates feature flag is off.
 */
export const UnlayerEmailsTabView = () => {
	const theme = useTheme();
	const { getFeatureFlags, isLoading, isUninitialized } = useFeatureFlagContext();

	const showUnlayerAiTemplates = Boolean(
		getFeatureFlags('unlayerAiEmailTemplates')?.active,
	);

	const unlayerTabs = useMemo(() => {
		const tabs = getUnlayerEmailTabs();
		if (!showUnlayerAiTemplates) {
			return tabs.filter((tab) => tab.value !== 'ai-templates');
		}
		return tabs;
	}, [showUnlayerAiTemplates]);

	if (isLoading || isUninitialized) {
		return null;
	}

	return (
		<NoContextTabView
			tabs={unlayerTabs}
			title='Emails'
			icon={
				<TemplatesIcon
					{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
				/>
			}
		/>
	);
};
